const topics = [
  { label: '古装权谋', heat: '1.28亿', icon: 'ri-vip-crown-line' },
  { label: '悬疑烧脑', heat: '9,600万', icon: 'ri-search-eye-line' },
  { label: '科幻末日', heat: '8,200万', icon: 'ri-planet-line' },
  { label: '民国谍战', heat: '7,500万', icon: 'ri-spy-line' },
  { label: '国漫崛起', heat: '6,800万', icon: 'ri-brush-4-line' },
  { label: '治愈日常', heat: '5,400万', icon: 'ri-cup-line' },
  { label: '都市情感', heat: '4,900万', icon: 'ri-heart-pulse-line' },
  { label: '热血动作', heat: '4,300万', icon: 'ri-fire-line' },
  { label: '搞笑喜剧', heat: '3,800万', icon: 'ri-emotion-laugh-line' },
  { label: '恐怖惊悚', heat: '3,200万', icon: 'ri-ghost-smile-line' },
  { label: '青春校园', heat: '2,600万', icon: 'ri-book-open-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          当前最受关注的热门类型与话题标签
        </p>

        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="group flex items-center gap-2.5 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <i className={`${topic.icon} text-primary-500 text-sm`}></i>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
              <span className="text-[10px] text-accent-600 font-semibold whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}